module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5r6r8r7r-203865a0f8630ba67435c98735ac70ab.svg";